import { INCOTERMS } from '../constants/partners.js';
import { z } from 'zod';
import { businessTermScopeSchema } from './setup.js';
import { idSchema, percentSchema } from './common.js';
import { supportedLocaleSchema } from './plm-material.js';
export const businessTermKindSchema = z.enum(['PAYMENT', 'DELIVERY']);
const common = {
    name: z.string().trim().min(1).max(160),
    nameLocale: supportedLocaleSchema.optional(),
    translations: z.record(supportedLocaleSchema, z.string().trim().min(1).max(160)).default({}),
    scope: businessTermScopeSchema.default('SALES'),
    isActive: z.boolean().default(true),
    isDefault: z.boolean().default(false),
};
export const businessTermWriteSchema = z.discriminatedUnion('kind', [
    z
        .object({
        ...common,
        kind: z.literal('PAYMENT'),
        dueDays: z.number().int().min(0).max(3650),
        cashDiscountPct: percentSchema.default('0'),
        cashDiscountDays: z.number().int().min(0).max(3650).default(0),
    })
        .strict(),
    z
        .object({
        ...common,
        kind: z.literal('DELIVERY'),
        incoterm: z.enum(INCOTERMS).nullable().default(null),
    })
        .strict(),
]);
export const businessTermSchema = z.discriminatedUnion('kind', [
    businessTermWriteSchema.options[0]
        .extend({
        id: idSchema,
        code: z.string(),
        name: z.string(),
        translations: z.record(z.string(), z.string()),
    })
        .strip(),
    businessTermWriteSchema.options[1]
        .extend({
        id: idSchema,
        code: z.string(),
        name: z.string(),
        translations: z.record(z.string(), z.string()),
    })
        .strip(),
]);
export const businessTermListSchema = z.object({ data: z.array(businessTermSchema) });
export function businessTermLabel(term, locale) {
    return term.translations[locale.split('-')[0] ?? locale] ?? term.name;
}
//# sourceMappingURL=business-term.js.map